import React, { useState } from "react";
import { TextField, Button, Box, Typography, Paper } from "@mui/material";
import { apiMain } from "../../App";
import { PostDataPromise } from "../Functions/SendingData";

export default function ResetPassword() {
  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleReset = async (e) => {
    e.preventDefault();

    if (!email || !newPassword) {
      alert("Please fill in all fields");
      return;
    }

    try {
      setLoading(true);
      let formdata = new FormData;
      formdata.append("U_Name", email);
      formdata.append("U_Password", newPassword);
  
      const body = {
        U_Name:email,
        U_Password: newPassword,
      };
      console.log(body)
  //const U_id=    localStorage.getItem("U_id");
      const res = await PostDataPromise(`${apiMain}/api/v1/users/update`, formdata,true);
      const parsed = JSON.parse(res);

      if (parsed.status === "success") {
        alert("Your password has been updated successfully.");
      } else {
        alert("Error: " + parsed.message);
      }
    } catch (error) {
      alert("Unexpected error while resetting password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
      <Paper elevation={3} sx={{ p: 4, width: 400, borderRadius: 3 }}>
        <Typography variant="h5" align="center" gutterBottom>
        Change Password by Email  
        </Typography>
        <form onSubmit={handleReset}>
          <TextField
            fullWidth
            margin="normal"
            type="email"
            label="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <TextField
            fullWidth
            margin="normal"
            type="password"
            label="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
          <Button
            fullWidth
            type="submit"
            variant="contained"
            sx={{ mt: 2 }}
            disabled={loading}
          >
            {loading ? "Saving..." : "Save New Password"}
          </Button>
        </form>
      </Paper>
    </Box>
  );
}
